module.exports = __webpack_public_path__ + "static/adedipe-9bf0946bc6e29af8d2df8b5aa206bef7.jpg";